export default "__VITE_ASSET__4107a7d3__"